import api, { apiErrorHandler } from "api";
import { Dispatch } from "redux";
import { DaAndFleetConstants, daStatusConstants, fleetStatusConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { customToast } from "hooks/toast";

export const getAllDriversData =
  (
    page?: number,
    page_size?: number,
    ordering?: string,
    stations?: string,
    statuses?: string,
    search?: string,
  ) =>
  async (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: DaAndFleetConstants.DA_FLEET_ERROR });
    dispatch({ type: DaAndFleetConstants.DA_FLEET_LOADING });

    api
      .getDriverUsersList({
        page,
        page_size,
        ordering,
        stations,
        statuses,
        search,
      })
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: DaAndFleetConstants.DA_FLEET_GET_ALL_DRIVERS_SUCCESS,
            payload: res?.data,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const getAllFleetsData =
  (
    page?: number,
    page_size?: number,
    ordering?: string,
    stations?: string,
    statuses?: string,
    search?: string,
  ) =>
  async (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: DaAndFleetConstants.DA_FLEET_ERROR });
    dispatch({ type: DaAndFleetConstants.DA_FLEET_LOADING });

    api
      .getAllVans({
        page,
        page_size,
        ordering,
        stations,
        statuses,
        search,
      })
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: DaAndFleetConstants.DA_FLEET_GET_ALL_FLEEETS_SUCCESS,
            payload: res?.data,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const daUpdateSettings = (data: any) => async (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
    payload: { pageNumber: 0, ...data},
  });
};

export const daUpdateTableSettings = (data: any) => async (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
    payload: data,
  });
};

export const fleetUpdateSettings = (data: any) => async (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
    payload: { pageNumber: 0, ...data},
  });
};

export const fleetUpdateTableSettings = (data: any) => async (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
    payload: data,
  });
};

export const daUpdateDateSettings =
  (data: any) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      driverData: { driverListFilters },
    } = getStore()?.daAndFleets;
    dispatch({
      type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
      payload: { dateFilters: { ...driverListFilters?.dateFilters, ...data } },
    });
  };

export const fleetUpdateDateSettings =
  (data: any) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      fleetData: { fleetListFilters },
    } = getStore()?.daAndFleets;
    dispatch({
      type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
      payload: { dateFilters: { ...fleetListFilters?.dateFilters, ...data } },
    });
  };

export const daSelectAllStationsFilters = () => (dispatch: Dispatch, getStore: () => RootState) => {
  const {
    userData: { station_spots },
  } = getStore()?.auth;
  const {
    driverData: { driverListFilters },
  } = getStore()?.daAndFleets;

  const newData =
    driverListFilters?.stations && driverListFilters?.stations?.length < station_spots.length
      ? [...station_spots.map((spot) => spot.station.id)]
      : [1];

  dispatch({
    type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
    payload: { pageNumber: 0, stations: newData },
  });
};

export const fleetSelectAllStationsFilters =
  () => (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      userData: { station_spots },
    } = getStore()?.auth;
    const {
      fleetData: { fleetListFilters },
    } = getStore()?.daAndFleets;

    const newData =
      fleetListFilters?.stations && fleetListFilters?.stations?.length < station_spots.length
        ? [...station_spots.map((spot) => spot.station.id)]
        : [1];

    dispatch({
      type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
      payload: { pageNumber: 0, stations: newData },
    });
  };

export const daSelectAllStatusFilters = () => (dispatch: Dispatch, getStore: () => RootState) => {
  const {
    driverData: { driverListFilters },
  } = getStore()?.daAndFleets;

  const newData =
    driverListFilters?.statuses && driverListFilters?.statuses?.length < daStatusConstants.length
      ? [...daStatusConstants.map((status) => status.value)]
      : [1];

  dispatch({
    type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
    payload: { pageNumber: 0, statuses: newData },
  });
};

export const fleetSelectAllStatusFilters =
  () => (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      fleetData: { fleetListFilters },
    } = getStore()?.daAndFleets;

    const newData =
      fleetListFilters?.statuses && fleetListFilters?.statuses?.length < fleetStatusConstants.length
        ? [...fleetStatusConstants.map((status) => status.value)]
        : [1];

    dispatch({
      type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
      payload: { pageNumber: 0, statuses: newData },
    });
  };

export const resetDATableColumns = () => (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.DA_UPDATE_SETTINGS,
    payload: {
      activeColumns: [
        "full_name",
        "badge",
        "transporter_id",
        "status",
        "created",
        "stations",
      ],
    },
  });
};

export const resetFleetTableColumns = () => (dispatch: Dispatch) => {
  dispatch({
    type: DaAndFleetConstants.FLEET_UPDATE_SETTINGS,
    payload: {
      activeColumns: [
        "number",
        "van_group",
        "fleet_size",
        "plate_number",
        "status",
        "comment",
      ],
    },
  });
};

export const addOrRemoveIdFromUpdateList =
  (type: "fleet" | "da", id: number) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { driverData, fleetData } = getStore()?.daAndFleets;
    const actionType =
      type === "da"
        ? DaAndFleetConstants.DA_FEET_SET_DA_ID_LIST
        : DaAndFleetConstants.DA_FEET_SET_FLEET_ID_LIST;
    const globalStateObject = type === "da" ? driverData : fleetData;
    let newData = null;

    if (!globalStateObject.idListForUpdate.includes(id)) {
      newData = [...globalStateObject.idListForUpdate, id];
    } else {
      newData = [
        ...globalStateObject.idListForUpdate.filter((item: number) => {
          return item !== id;
        }),
      ];
    }
    dispatch({
      type: actionType,
      payload: newData,
    });
  };

export const selectAllFleetIdsList = () => (dispatch: Dispatch, getStore: () => RootState) => {
  const { fleetData } = getStore()?.daAndFleets;
  const newData =
    fleetData.idListForUpdate.length !== fleetData?.fleetList.length
      ? fleetData?.fleetList.map((data) => data.id)
      : [];
  dispatch({
    type: DaAndFleetConstants.DA_FEET_SET_FLEET_ID_LIST,
    payload: newData,
  });
};

export const selectAllDaIdsList = () => (dispatch: Dispatch, getStore: () => RootState) => {
  const { driverData } = getStore()?.daAndFleets;
  const newData =
    driverData.idListForUpdate.length !== driverData?.driverList.length
      ? driverData?.driverList.map((data) => data.id)
      : [];
  dispatch({
    type: DaAndFleetConstants.DA_FEET_SET_DA_ID_LIST,
    payload: newData,
  });
};

export const resetDaSelectedList = () => (dispatch: Dispatch, getStore: () => RootState) => {
  dispatch({
    type: DaAndFleetConstants.DA_FEET_SET_DA_ID_LIST,
    payload: [],
  });
};

export const resetFleetSelectedList = () => (dispatch: Dispatch, getStore: () => RootState) => {
  dispatch({
    type: DaAndFleetConstants.DA_FEET_SET_FLEET_ID_LIST,
    payload: [],
  });
};

export const EditDriverData =
  (id: number, data: any) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { driverData } = getStore()?.daAndFleets;
    const onError = () => dispatch({ type: DaAndFleetConstants.DA_FLEET_ERROR });
    dispatch({ type: DaAndFleetConstants.DA_FLEET_LOADING });
    api
      .updateUserInformation(id, data)
      .then((res) => {
        if (res.data) {
          customToast("success", "Driver data was changed!");
          const newData = driverData?.driverList?.map((item) =>
            item.id === id
              ? {
                  ...item,
                  ...data,
                  station_spots: res.data.data.data_list,
                  last_edit: res.data.data.last_edit,
                  last_edited_by: res.data.data.last_edited_by,
                }
              : item,
          );
          dispatch({
            type: DaAndFleetConstants.UPDATE_DA_SUCCESS,
            payload: newData,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const EditFleetAction =
  (van_id: number, data: any) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { fleetData } = getStore()?.daAndFleets;
    const onError = () => dispatch({ type: DaAndFleetConstants.DA_FLEET_ERROR });
    dispatch({ type: DaAndFleetConstants.DA_FLEET_LOADING });
    api
      .patchVan(van_id, data)
      .then((res) => {
        const newData = fleetData.fleetList.map((el) =>
          el.id === van_id
            ? {
                ...el,
                ...data,
                station: data.station,
                last_edit: res.data.last_edit,
                last_edited_by: res.data.last_edited_by,
              }
            : el,
        );
        if (res.data) {
          dispatch({
            type: DaAndFleetConstants.UPDATE_FLEET_SUCCESS,
            payload: newData,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const updateMultipleUsersStatusAction =
  (status: number, id_list: number[]) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { driverData } = getStore()?.daAndFleets;
    api
      .updateUserStatus({
        status,
        id_list,
      })
      .then((res) => {
        customToast("success", "Driver statuses was changed!");
        const newData = driverData.driverList.map((item) =>
          id_list.includes(item?.id)
            ? {
                ...item,
                status: status,
                last_edit: res.data.date,
                last_edited_by: res.data.editor,
                ...(status === 1
                  ? {
                      is_active: true,
                    }
                  : {
                      is_active: false,
                    }),
              }
            : item,
        );
        dispatch({
          type: DaAndFleetConstants.UPDATE_DA_SUCCESS,
          payload: newData,
        });
      })
      .catch(
        apiErrorHandler(() => {
          customToast("error", "Failed to update drivers status");
        }),
      );
  };

export const updateMultipleFleetStatusAction =
  (status: number, id_list: number[]) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { fleetData } = getStore()?.daAndFleets;
    api
      .updateFleetStatus({
        status,
        id_list,
      })
      .then((res) => {
        customToast("success", "Fleet statuses was changed!");
        const newData = fleetData.fleetList.map((item) =>
          id_list.includes(item?.id)
            ? {
                ...item,
                status: status,
                last_edit: res.data.date,
                last_edited_by: res.data.editor,
                ...(status === 1
                  ? {
                      available: true,
                    }
                  : {
                      available: false,
                    }),
              }
            : item,
        );
        dispatch({
          type: DaAndFleetConstants.UPDATE_FLEET_SUCCESS,
          payload: newData,
        });
      })
      .catch(
        apiErrorHandler(() => {
          customToast("error", "Failed to update fleet status");
        }),
      );
  };
